import { render, staticRenderFns } from "./MySubscription.vue?vue&type=template&id=228c7858&scoped=true&"
import script from "./MySubscription.vue?vue&type=script&lang=js&"
export * from "./MySubscription.vue?vue&type=script&lang=js&"
import style0 from "./MySubscription.vue?vue&type=style&index=0&id=228c7858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228c7858",
  null
  
)

export default component.exports